module.exports = __webpack_public_path__ + "static/media/vc3.6cef6249.png";